import { render, staticRenderFns } from "./PeopleAvatarsButton.vue?vue&type=template&id=32b2978e&scoped=true"
import script from "./PeopleAvatarsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleAvatarsButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PeopleAvatarsButton.vue?vue&type=style&index=0&id=32b2978e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2978e",
  null
  
)

export default component.exports